import React, { useState, useEffect, Children } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Radio, Divider, Form, Input, message, Button, TimePicker, DatePicker,Select, Cascader } from "antd";
import moment from 'moment'
import editIcon from "../../../assets/pencil.png";
import { CloseOutlined } from "@ant-design/icons";

import useJDStore from "../../../store/jd.store";
import useMembersStore from "../../../store/members.store";
import {ROLE_OPTIONS, ROLE_TYPE_OPTIONS, SUPPORTED_JOB_CATEGORY, SUPPORTED_LOCATION, WORK_OPTIONS} from "../../../helper/categoryconstants" 
import "./nujobsViewjob.scss";
import TextArea from "antd/es/input/TextArea";
import { Space } from "antd";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";
import NuJobsViewJobDetails from "../nujobsViewJobDetails";

export default function NuJobsViewJob({
  jdid,
  appliedJobs,
  openJd,
  setAppliedJobs,
  idx,
  handleViewJob,
  loggedIn,
  handleClickApply
}) {
    const [isEditMode, setIsEditMode] = useState(false);
    const [formKey, setFormKey] = useState(1);
    const [form] = Form.useForm();
    
    const navigate = useNavigate();
    const { myJds,nujobsApplyNow,nuJobsGetMyJDs } = useNuJobDetailsStore();
    const { setMetaDataViewed } = useNuJobsStore();
    const [jdValues, setJdValues] = useState({});     
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    } 
    
    function keysToLowerCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(keysToLowerCase);
    } else if (obj !== null && typeof obj === "object") {
        return Object.keys(obj).reduce((acc, key) => {
        acc[key.toLowerCase()] = keysToLowerCase(obj[key]);
        return acc;
        }, {});
    }
    return obj;
    }   

  const jd = openJd
  const selectedJD = keysToLowerCase(jd)
  const getCompanyLogoSrc = (rawLogo) => {
    if (!rawLogo) return null;
    if (rawLogo.startsWith("data:image")) return rawLogo;
    return `data:image/png;base64,${rawLogo}`;
  };
  const companyLogoSrc =
    getCompanyLogoSrc(
      openJd?.companylogo ||
        openJd?.JDClient?.CompanyLogo,
    ) || null;

    const isApplied = ()=>{
        //check in myJds if the jd is applied by matching qhcompanyjid and qhoid with selectedJD
        const applied = myJds?.find(j => j.nujobsinfo?.qhcompanyjid === selectedJD.qhcompanyjid && j.nujobsinfo?.qhoid === selectedJD?.qhoid)
        if(applied){
                return "Applied"
        }else{
                return "Not Applied"
        }
        return "Not Applied"
    }
    const appliedOn = ""
    const initJDParams = () =>{
        var jdValuesTmp
        if (jd !== undefined) {
            jdValuesTmp = {
                job_category: selectedJD?.jddetails.jobcategory,
                title: selectedJD?.jddetails.title,
                client_job_type: selectedJD?.jdclient.clientjobtype,
                job_type: selectedJD?.jddetails.jobtype,
                job_time: selectedJD?.jddetails.jobtime,
                designation: selectedJD?.jddetails.designation,
                roles_and_responsibility: selectedJD?.jdrequired.roledetails,
                roletype: selectedJD?.jdrequired.roletype,
                role: selectedJD?.jdrequired.role,
                skills: selectedJD?.jdrequired.skills,
                keywords: selectedJD?.jdrequired.keywords,
                education: selectedJD?.jdrequired.education,
                min_ctc: selectedJD?.jdproject.minctc,
                max_ctc: selectedJD?.jdproject.maxctc,
                postingdate: selectedJD?.jdother.postingdate,
                work_location: selectedJD?.jdrequired.worklocation,
                work_mode: selectedJD?.jdrequired.workmode,
                diversity_only: selectedJD?.jdrequired.diversity,
                freshers_only: selectedJD?.jdrequired.fresher,
                interns_only: selectedJD?.jdrequired.interns,                                                                          
                notice_period: selectedJD?.jdrequired.noticeperiod,
                min_exp: selectedJD?.jdrequired.minexperience,
                max_exp: selectedJD?.jdrequired.maxexperience,
                updatedon: formatUnixDate(selectedJD?.timestamp),
                postedby: selectedJD?.companyname,             
            };
            setJdValues(jdValuesTmp);
        }
    }
    //selected jd from table
    useEffect(() => {      
        initJDParams(); 
        if(loggedIn){
            setMetaDataViewed(idx)
            if(handleViewJob) handleViewJob()
        }  
    }, []);


    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    const handleFormSubmit = async (values) => {
        const jasonValues = encodeJson(selectedJD)
        nujobsApplyNow(0,jasonValues)
    };
        
    const encodeJson = () =>{
        let encodedJsonValues ={};
       
        //now override keyword and location
        encodedJsonValues.qhoid= selectedJD?.qhoid;
        encodedJsonValues.qhcompanyjid=selectedJD?.qhcompanyjid;
        encodedJsonValues.companyname=selectedJD?.companyname;                           
        return encodedJsonValues
    }

    return (
           <NuJobsViewJobDetails
            jobId={jdid}
            jdValues= {jdValues} 
            encodeJsonCB = {encodeJson} 
            isApplied={isApplied} 
            appliedOn ={appliedOn}
            type={"search"}
            isDrawer="true"
            companyLogo={companyLogoSrc}
            appliedJobs={appliedJobs}
            setAppliedJobs={setAppliedJobs}
            openJd={openJd}
            isLoggedin={loggedIn}
            applyNowCallBackLoggedIn = {handleClickApply}
    />
    );
}
